import { useState } from "react";
import moment from "moment";
import { Button, Tooltip } from "antd";

import ArrowRight from "components/icons/ArrowRight";
import ls from "components/common/ListWithMoreOptions/ItemRow/styles";
import "../styles";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import ClockSessionRowForm from "./ClockSessionRowForm";
import { secondsToTime } from "helpers/dataHelper";

const ClockSessionRowMap = ({
  item,
  actions,
  // selectStore,
  setCurrentSession,
  updateEnabled,
}) => {
  const { t } = useTranslation();

  const [updating, setUpdating] = useState(false);

  /**
  useEffect(() => {
    if (!updateEnabled && updating) setUpdating(false);
  }, [updateEnabled, updating]);
    */

  if (updating) {
    return (
      <ClockSessionRowForm
        t={t}
        item={item}
        actions={actions}
        setUpdating={setUpdating}
      />
    );
  }

  return [
    <ls.TableCell key="sessionRowStart">
      {moment(item.sessionStart).isValid()
        ? moment(item.sessionStart).format("YYYY-MM-DD hh:mm A")
        : "-"}
    </ls.TableCell>,
    <ls.TableCell key="sessionRowEnd">
      {moment(item.sessionEnd).isValid()
        ? moment(item.sessionEnd).format("YYYY-MM-DD hh:mm A")
        : "-"}
    </ls.TableCell>,
    <ls.TableCell key="sessionRowType">
      {t(`containers.ClockSessions.session${item.type}`)}
    </ls.TableCell>,
    <ls.TableCell key="sessionDuration">
      {item.sessionDuration ? secondsToTime(item.sessionDuration, t) : "-"}
    </ls.TableCell>,
    <ls.TableCell key="sessionRowNotes">{item?.notes || "-"}</ls.TableCell>,
    <ls.TableCell
      key="sessionActionButtons"
      style={{
        display: "flex",
        justifyContent: "end",
        gap: "10px",
        width: "100%",
        paddingRight: "20px",
      }}
    >
      {updateEnabled ? (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "10px",
            width: "100%",
          }}
        >
          <Tooltip
            title={
              item.status === "open"
                ? t("containers.ClockSessions.messageSessionOpen")
                : ""
            }
          >
            <Button
              type={"text"}
              disabled={item.status === "open"}
              onClick={() => {
                setUpdating(true);
              }}
            >
              {t("containers.ClockSessions.edit")}
            </Button>
          </Tooltip>
        </div>
      ) : (
        <Button
          type="text"
          style={{
            color: Colors.primary,
            borderRadius: "2px",
            height: "30px",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {
            setCurrentSession(item);
          }}
        >
          <ArrowRight size="18" />
        </Button>
      )}
    </ls.TableCell>,
  ];
};

export default ClockSessionRowMap;
